type Props = {
  className?: string
  /** Accessible name; keep empty when a parent button already has aria-label */
  title?: string
  /** Wordmark PNG only — compact spots */
  wordmarkOnly?: boolean
  /** Warm silver-grey watermark (listing photos, no-photo preview) */
  watermark?: boolean
}

const MARK_SRC = '/logo-mark.png?v=4'
const WORDMARK_SRC = '/logo-wordmark-gradient.png?v=2'

/** Radial mark + gradient wordmark PNG — shared brand lockup (same as header). */
export default function BrandWordmark({
  className = '',
  title = 'reDevicer',
  wordmarkOnly = false,
  watermark = false,
}: Props) {
  return (
    <span
      className={`brand-lockup${watermark ? ' brand-watermark' : ''} ${className}`.trim()}
      title={title || undefined}
    >
      {!wordmarkOnly ? (
        <img src={MARK_SRC} alt="" className="brand-lockup__mark" decoding="async" draggable={false} />
      ) : null}
      <img
        src={WORDMARK_SRC}
        alt={wordmarkOnly ? title || 'reDevicer' : ''}
        className="brand-lockup__wordmark-img"
        decoding="async"
        draggable={false}
      />
    </span>
  )
}
